import mod from "-!./place-input.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./place-input.js?vue&type=script&lang=js&external"